import { TaxRate } from '../TaxRate';
export class TaxRateLocalizationMe {
    taxRate;
    constructor(taxRate) {
        this.taxRate = taxRate;
    }
    static productTaxRates() {
        return TaxRate.all().filter(taxRate => taxRate.type === TaxRate.TYPE_PRODUCT);
    }
}
const TaxRateLocalizationMeStatic = TaxRateLocalizationMe;
//# sourceMappingURL=TaxRateLocalizationMe.js.map